import React, { Component } from 'react';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { RouteComponentProps } from 'react-router-dom';
import userApi from '../../../apis/UserApi';
import LayoutComponent from '../../../components/LayoutComponent/LayoutComponent';
import UserAccountEditComponent from '../../../components/UserAccountEditComponent/UserAccountEditComponent';
import { UserAccount } from '../../../model/Entities';
import HeadMetadata from '../../../services/HeadMetadata';
import notificationService from '../../../services/NotificationService';
import styles from './AffiliateStaffEditPage.module.scss';

class AffiliateStaffEditPage extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.init();
    }

    /** METHODS **/

    /**
     * Initializes the edit page.
     */
    init = async () => {
        try {
            this.setState({ loading: 'loading' });

            const params = new URLSearchParams(this.props.location.search);
            const organizationId = params.get('organizationId')?.toString();

            const userAccount = await userApi.getAccount(this.props.match.params.id);

            this.setState({ userAccount, organizationId });
        } catch (error) {
            notificationService.displayError(error, this.props.intl);
        } finally {
            this.setState({ loading: undefined });
        }
    };

    /**
     * Refreshes the user account.
     * @param userAccount the user account
     */
    refreshUserAccount = (userAccount: UserAccount) => {
        this.setState({ userAccount });
    };

    /*** COMPONENTS ***/
    renderHeader = (desktop: boolean): React.ReactElement | undefined => {
        return (
            <div className={styles.header}>
                <h1>
                    <FormattedMessage id="parent.edit.title" />
                </h1>
            </div>
        );
    };

    renderContent = (): React.ReactElement | undefined => {
        const { userAccount, organizationId } = this.state;
        const userId = this.props.match.params.id;

        return (
            userAccount && (
                <UserAccountEditComponent
                    userAccount={userAccount}
                    userId={this.props.match.params.id}
                    onSave={this.refreshUserAccount}
                    backUrl={`/affiliate-staffs/${userId}?organizationId=${organizationId}`}
                />
            )
        );
    };

    render() {
        const { loading, userAccount } = this.state;
        const fullName =
            userAccount &&
            `${userAccount?.givenName} ${userAccount?.familyName} - ${this.props.intl.formatMessage({
                id: 'affiliateEdit',
            })}`;

        return (
            <div className={styles.edit}>
                <HeadMetadata title={fullName} />
                <LayoutComponent
                    page="organization-user-profile"
                    content={this.renderContent}
                    header={this.renderHeader}
                    loading={loading === 'loading'}
                    userId={this.props.match.params.id}
                />
            </div>
        );
    }
}
export default injectIntl(AffiliateStaffEditPage);

type ParamsType = { id: string };
interface Props extends RouteComponentProps<ParamsType>, WrappedComponentProps {}

interface State {
    userAccount?: UserAccount;
    loading?: 'loading';
    organizationId?: string;
}
